import React, {
    useState,
    useEffect
} from "react";
import {
    Button,
    Modal
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

export const ConfirmationModal = (props) => {
    const [bulkLinks, setBulkLinks] = useState(props.bulklinks)
    useEffect(() => {
        setBulkLinks(props.bulklinks)
    }, [props.bulklinks])

    function downloadURI(url, name) {
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        window.open(url)
        document.body.removeChild(link);
    }

    const downloadFiles = () => {
        // console.log("BULK LINKS: ", bulkLinks)
        for (let url of bulkLinks) {
            downloadURI(url, "file.xlsx")
        }
        props.onHide()
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            scrollable="false"
            className={"smallmodal"}
        >
            <Modal.Header closeButton>
                <h5><Icon.ExclamationDiamondFill fill="red" /> &nbsp;Not all selected files are verified!</h5>
            </Modal.Header>
            <Modal.Body>
                Only verified files will get downloaded.
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <div className="intent-buttons">
                    <Button className="intent-save" onClick={() => downloadFiles()}> Download</Button>
                    <Button className="intent-skip" onClick={() => props.onHide()}> Leave </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}